import _ from 'lodash';
import { logErrorToConsole, TravelTypes } from '../constants';
import arePassengerCountsEqual from './checkArePassengerCountsEqual';

const getBrochureTripId = (tripId, brochureData, itinerary, staterooms, itineraryMode) => {
  try {
    const trips = brochureData.trips || {};

    const keyCheckers = {
      [TravelTypes.flight]: (segment) => segment?.itinerary?.flightKey === itinerary.flightKey,
      [TravelTypes.hotel]: (segment) => segment?.itinerary?.hotelKey === itinerary.hotelKey,
      [TravelTypes.carrental]: (segment) => segment?.itinerary?.uniqueKey === itinerary.uniqueKey,
      [TravelTypes.tour]: (segment) => segment?.itinerary?.uniqueKey === itinerary.uniqueKey,
      [TravelTypes.cruise]: (segment) =>
        segment?.itinerary?.itineraryDetail?.itineraryId === itinerary.itineraryId,
    };

    const isMatchingSegment = (segment, trip) => {
      if (segment?.itinerary?.mode !== itineraryMode) return false;
      const doMatchesKey = keyCheckers?.[itineraryMode]?.(segment) || false;
      const isStateroomsMatched = arePassengerCountsEqual(
        trip?.staterooms ?? trip?.roomSearchInput,
        staterooms,
      );

      if (itineraryMode === TravelTypes.cruise) {
        const { itineraryDetail } = segment.itinerary;
        return (
          doMatchesKey &&
          isStateroomsMatched &&
          itinerary?.itineraryDepartDate === itineraryDetail?.itineraryDepartDate &&
          itinerary?.itineraryReturnDate === itineraryDetail?.itineraryReturnDate
        );
      }
      return (
        doMatchesKey &&
        segment?.itinerary?.startDateTime === itinerary?.startDateTime &&
        segment?.itinerary?.endDateTime === itinerary?.endDateTime &&
        isStateroomsMatched
      );
    };

    const foundTripId = _.findKey(trips, (trip) =>
      _.some(trip.tripSegments, (segment) => isMatchingSegment(segment, trip)),
    );

    return foundTripId || tripId;
  } catch (error) {
    logErrorToConsole('Error in getBrochureTripId:', error);
    return undefined;
  }
};

export default getBrochureTripId;
